"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _emotionTheming = require("emotion-theming");

var _reactTransitionGroup = require("react-transition-group");

var _classnames = _interopRequireDefault(require("classnames"));

var _NormalButton = _interopRequireDefault(require("../Button/NormalButton"));

var _DarkSquareBorderButton = _interopRequireDefault(require("../Button/DarkSquareBorderButton"));

var _AccentButton = _interopRequireDefault(require("../Button/AccentButton"));

var _PopupPortal = _interopRequireDefault(require("./PopupPortal"));

var _Popup = _interopRequireDefault(require("./Popup.style"));

var _class, _temp;

var stop = function stop(e) {
  e.stopPropagation(); // e.preventDefault();
};

var transitionStyles = {
  entering: {
    opacity: '0',
    transition: 'all 300ms ease'
  },
  entered: {
    opacity: '1',
    transition: 'all 300ms ease'
  },
  exiting: {
    opacity: '0',
    transition: 'all 300ms ease'
  }
};

var DarkPopup = (0, _emotionTheming.withTheme)(_class = (_temp =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DarkPopup, _PureComponent);

  function DarkPopup() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DarkPopup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DarkPopup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderHeader", function () {
      var _this$props = _this.props,
          theme = _this$props.theme,
          header = _this$props.header,
          onCloseClick = _this$props.onCloseClick,
          stickyHeader = _this$props.stickyHeader,
          backButtonProps = _this$props.backButtonProps;
      if ((0, _isEmpty.default)(header)) return null;
      return _react.default.createElement("header", {
        className: _Popup.default.header(theme, stickyHeader)
      }, backButtonProps && _react.default.createElement("div", {
        className: _Popup.default.headerBackButtonTitle(theme)
      }, _react.default.createElement(_AccentButton.default, {
        onClick: backButtonProps.onClick,
        icon: {
          type: 'angle-left',
          style: {
            width: '18px',
            fill: theme.color.dark.silver,
            marginLeft: '-28px'
          }
        }
      }), _react.default.createElement("p", {
        className: _Popup.default.headerText(theme)
      }, header.title)), !backButtonProps && _react.default.createElement("p", {
        className: _Popup.default.headerText(theme)
      }, header.title), header.iconClassName ? _react.default.createElement(_NormalButton.default, {
        icon: {
          type: 'close',
          className: header.iconClassName
        },
        className: _Popup.default.headerButton(theme),
        onClick: onCloseClick
      }) : _react.default.createElement(_NormalButton.default, {
        icon: {
          type: 'close'
        },
        className: _Popup.default.headerButton(theme),
        onClick: onCloseClick
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderBody", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          theme = _this$props2.theme,
          bodyClassName = _this$props2.bodyClassName,
          stickyFooter = _this$props2.stickyFooter,
          stickyHeader = _this$props2.stickyHeader,
          mainBodyStyle = _this$props2.mainBodyStyle;
      return _react.default.createElement("main", {
        className: (0, _classnames.default)(_Popup.default.main(theme, stickyHeader, stickyFooter), bodyClassName),
        style: mainBodyStyle
      }, children);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderFooter", function () {
      var _this$props3 = _this.props,
          theme = _this$props3.theme,
          footer = _this$props3.footer,
          stickyFooter = _this$props3.stickyFooter,
          footerText = _this$props3.footerText,
          footerComponent = _this$props3.footerComponent;

      if (footerComponent && _react.default.isValidElement(footerComponent)) {
        if (footerComponent.type === 'footer') {
          return footerComponent;
        }

        return _react.default.createElement("footer", {
          className: _Popup.default.footer(theme, stickyFooter)
        }, footerComponent);
      }

      if ((0, _isEmpty.default)(footer)) return null;
      return _react.default.createElement("footer", {
        className: _Popup.default.footer(theme, stickyFooter)
      }, _react.default.createElement("div", null, typeof footerText === 'string' ? _react.default.createElement("p", {
        className: (0, _classnames.default)(_Popup.default.footerText(theme))
      }, footerText) : footerText), _react.default.createElement("div", null, footer.map(function (btn) {
        return _react.default.createElement(_DarkSquareBorderButton.default, btn, _react.default.createElement("div", {
          style: {
            paddingLeft: '10px',
            paddingRight: '10px'
          }
        }, btn.text));
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderPopupContent", function () {
      var _this$props4 = _this.props,
          theme = _this$props4.theme,
          popupStyle = _this$props4.popupStyle,
          popupClassName = _this$props4.popupClassName,
          className = _this$props4.className,
          onOverlayClick = _this$props4.onOverlayClick,
          stickyFooter = _this$props4.stickyFooter,
          stickyHeader = _this$props4.stickyHeader,
          style = _this$props4.style,
          showPopup = _this$props4.showPopup;
      return _react.default.createElement(_reactTransitionGroup.Transition, {
        timeout: 300,
        in: showPopup
      }, function (state) {
        return state === 'exited' ? null : _react.default.createElement("div", {
          className: _Popup.default.overlay(theme),
          onClick: onOverlayClick,
          role: "button",
          tabIndex: "0",
          style: (0, _objectSpread2.default)({}, style, transitionStyles[state])
        }, (stickyHeader && stickyFooter || !stickyHeader && !stickyFooter) && _react.default.createElement("section", {
          onClick: stop,
          role: "presentation",
          className: (0, _classnames.default)(_Popup.default.popup(theme, stickyHeader, stickyFooter), popupClassName, className),
          style: popupStyle
        }, _this.renderHeader(), _this.renderBody(), _this.renderFooter()), stickyHeader && !stickyFooter && _react.default.createElement("section", {
          onClick: stop,
          role: "presentation",
          className: (0, _classnames.default)(_Popup.default.popup(theme, stickyHeader, stickyFooter), popupClassName, className),
          style: popupStyle
        }, _this.renderHeader(), _react.default.createElement("section", {
          className: _Popup.default.body(stickyHeader, stickyFooter)
        }, _this.renderBody(), _this.renderFooter())), !stickyHeader && stickyFooter && _react.default.createElement("section", {
          onClick: stop,
          role: "presentation",
          className: (0, _classnames.default)(_Popup.default.popup(theme, stickyHeader, stickyFooter), popupClassName, className),
          style: popupStyle
        }, _react.default.createElement("section", {
          className: _Popup.default.body(stickyHeader, stickyFooter)
        }, _this.renderHeader(), _this.renderBody()), _this.renderFooter()));
      });
    });
    return _this;
  }

  (0, _createClass2.default)(DarkPopup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var popupWrapperZIndex = this.props.popupWrapperZIndex;
      this.popupNode = document.createElement('div');
      this.popupNode.style = 'position: absolute; top: 0px; left: 0px;z-index: ' + popupWrapperZIndex + ';';
      document.body.appendChild(this.popupNode);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.popupNode && this.popupNode.parentNode.removeChild(this.popupNode);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          popupWrapperClassName = _this$props5.popupWrapperClassName,
          withPortal = _this$props5.withPortal;

      if (withPortal) {
        return _react.default.createElement(_PopupPortal.default, {
          popupNode: this.popupNode,
          content: this.renderPopupContent(),
          close: this.close,
          popupWrapperClassName: popupWrapperClassName
        });
      }

      return this.renderPopupContent();
    }
  }]);
  return DarkPopup;
}(_react.PureComponent), _temp)) || _class;

DarkPopup.defaultProps = {
  header: {},
  mainBodyStyle: {},
  footer: [],
  onCloseClick: function onCloseClick() {
    return null;
  },
  onOverlayClick: function onOverlayClick() {
    return null;
  },
  popupStyle: {},
  popupClassName: undefined,
  bodyClassName: undefined,
  footerText: '',
  footerComponent: null,
  showPopup: false
};
DarkPopup.propTypes = {
  popupStyle: _propTypes.default.shape({}),
  popupClassName: _propTypes.default.string,
  bodyClassName: _propTypes.default.string,
  onCloseClick: _propTypes.default.func,
  onOverlayClick: _propTypes.default.func,
  header: _propTypes.default.shape({
    title: _propTypes.default.string,
    iconClassName: _propTypes.default.string
  }),
  mainBodyStyle: _propTypes.default.shape({}),
  footer: _propTypes.default.arrayOf(_propTypes.default.shape(_DarkSquareBorderButton.default.propTypes)),
  footerText: _propTypes.default.oneOf([_propTypes.default.string, _propTypes.default.element]),
  footerComponent: _propTypes.default.element,
  showPopup: _propTypes.default.bool
};
var _default = DarkPopup;
exports.default = _default;